/*
 * Copyright (c) Nexign, JSC, 1992-2024.
 */
/**
 *
 *
 * @author Julia Ignatieva
 * @version 1.29.0
 * @since 1.29.0
 */
import styled from 'styled-components';

import { FlexColumnStyled } from '@components/common/Block/Flexbox';
import { LoaderFrameStyled } from '@modules/loader/components/styled/LoaderStyled';
import { colors, fonts } from '@theme/index';

export const ChangeSubscribersContainerStyled = styled.div.attrs({
    'className': 'change-subscribers',
    'data-footer-change-subscribers': 'change-subscribers',
})`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 600px;
    padding: 24px 0;
    box-sizing: border-box;

    & .change-subscribers__title, & .change-subscribers__search, & .change-subscribers__footer {
        padding: 0 24px;
        box-sizing: border-box;
    }
    & ${LoaderFrameStyled} {
        transform: translate(-50%, -50%);
    }
`;

export const ChangeSubscribersTextStyled = styled(FlexColumnStyled).attrs({
    className: 'change-subscribers__header',
})`
    padding: 24px 32px 0;
`;

export const ChangeSubscribersTitleStyled = styled.div.attrs({
    className: 'change-subscribers__title',
})`
    display: flex;
    ${fonts.textHeader3};
`;

export const ChangeSubscribersCheckedContainer = styled.div.attrs({
    'className': 'change-subscribers__checked',
})`
    display: flex;
    padding: 24px 32px 0;
`;

export const ChangeSubscribersCheckedElementContainer = styled.div.attrs({
    'className': 'change-subscribers__checked',
})`
    margin-right: 12px;
`;

export const ChangeSubscribersFooterStyled = styled.div.attrs({
    'className': 'change-subscribers__footer',
    'data-change-subscribers-footer': 'change-subscribers-footer',
})`
    display: flex;
    align-items: center;
    margin-top: 24px;
    & .change-subscribers__footer-link {
        margin-left: 16px;
    }
`;

export const ChangeSubscribersSearchStyled = styled.div.attrs({
    'className': 'change-subscribers__search',
    'data-change-subscribers-search': 'change-subscribers-search',
})`
     display: flex;
     align-items: center;
     margin-top: 24px;
     width: 100%;
`;

export const ChangeSubscribersModalStyled = styled.div`
    max-height: 440px;
    overflow-y: auto;
    padding: 0 24px;
    border-top: 1px solid ${colors.borderColorDisabled};
    border-bottom: 1px solid ${colors.borderColorDisabled};
    margin-top: 24px;
    background-color: ${colors.backgroundColorModal};
`;

export const ChangeSubscribersListContainerStyled = styled.div.attrs({
    className: 'change-subscribers__item-container',
})`
    display: flex;
    flex-direction: column;
`;

export const ChangeSubscribersItemStyled = styled.div`
    display: flex;
    align-items: center;
    border-bottom: 1px solid ${colors.borderColorDisabled};
    box-sizing: border-box;
    padding-top: 8px;
    padding-bottom: 8px;

    &:last-child {
        border-bottom: none;
    }

    .change-subscribers__item-text_bold {
        font-weight: bold;
        line-height: 1;
        background: transparent;
    }

    .change-subscribers__item-checkbox {
        margin-left: 8px;
    }
`;

export const ChangeSubscribersNameStyled = styled.div`
    flex: 1;
    padding-left: 8px;
    position: relative;
    top: 2px;
    width: 100%;
    min-width: 1px;
`;
